var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "arranger",
    attrs: {
      "id": "arranger"
    }
  }, [_c('div', {
    staticClass: "tabs",
    attrs: {
      "id": "flap"
    }
  }, [_c('div', [_c('button', {
    staticClass: "tab selector",
    class: {
      'open': _vm.showFilters
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.showFilters = !_vm.showFilters;
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.getSelectedFilterName))])])]), _c('transition', {
    attrs: {
      "name": "slide-vertical"
    }
  }, [_vm.showFilters ? _c('div', [_c('button', {
    staticClass: "tab",
    class: _vm.getBtnClass('ALL'),
    on: {
      "click": function click($event) {
        return _vm.selectFilter('ALL');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.all')) + " ")]), _c('button', {
    staticClass: "tab",
    class: _vm.getBtnClass('ACTIVE'),
    on: {
      "click": function click($event) {
        return _vm.selectFilter('ACTIVE');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.active')) + " ")]), _c('button', {
    staticClass: "tab",
    class: _vm.getBtnClass('INACTIVE'),
    on: {
      "click": function click($event) {
        return _vm.selectFilter('INACTIVE');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.inactive')) + " ")])]) : _vm._e()])], 1), _c('div', {
    staticClass: "search-container"
  }, [_c('search-field', {
    on: {
      "process": _vm.onSearchProcessing
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }